<template>
  <div v-if="show" class="col-xs-12 col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly || isReadonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import verificaTipoPessoa from "../../../../mixins/protocolo/verificaTipoPessoa";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import { mapState } from "vuex";

export default {
  name: "c-protocolo-text-curto",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    id: String,
    campoId: Number
  },
  mixins: [verificaTipoPessoa],
  data() {
    return {
      show: true
    };
  },
  computed: {
    ...mapState("atendimento", ["isAlterarCampos"])
  },
  asyncComputed: {
    verificar() {
      if (this.id == 41 || this.id == 46) {
        this.show = !this.$isJuridica(this.formValues);
      }
    },
    isReadonly() {
      const campos = [
        CampoEnum.NOME_EMPRESA,
        CampoEnum.CNPJ,
        CampoEnum.CEP_EMPRESA,
        CampoEnum.ENDERECO_EMPRESA,
        CampoEnum.NUMERO_EMPRESA,
        CampoEnum.BAIRRO_EMPRESA,
        CampoEnum.CIDADE_EMPRESA,
        CampoEnum.ESTADO_EMPRESA
      ];
      return campos.includes(this.campoId) && !this.isAlterarCampos;
    }
  },
  methods: {
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TextCurto.vue